import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { CourseMappingColumn } from '../../interfaces/CourseMappingInterface';

interface CourseMappingHiddenColumnsMenuProps {
  columns: CourseMappingColumn[];
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onShowColumn: (columnKey: string) => void;
}

const CourseMappingHiddenColumnsMenu = ({
  columns,
  anchorEl,
  open,
  onClose,
  onShowColumn,
}: CourseMappingHiddenColumnsMenuProps) => {
  const handleShow = (columnKey: string) => {
    onShowColumn(columnKey);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      className="course-mapping-column-menu"
      PaperProps={{ className: 'course-mapping-dropdown-menu-paper' }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      {columns.map((column) => (
        <MenuItem key={column.key} className="course-mapping-column-menu-item" onClick={() => handleShow(column.key)}>
          <ListItemIcon>
            <VisibilityOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Show &ldquo;{column.label}&rdquo;</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default CourseMappingHiddenColumnsMenu;
